import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import { adminGetAllCenters } from 'services/center';
import { adminGetAllBoxes,	
	adminGetBoxById,
	adminPatchBox,
	adminDeleteBox,
	resetFocusBox,
	adminPostBox,
	initNewBox}
	from 'services/box';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/Boxes/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	name: Yup.string().required('Champ requis'),
});

class BoxesAdmin extends Component {

	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusBox();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllBoxes();
		this.props.adminGetAllCenters();
	};

	focusOnElement = (elt) => {
		this.props.adminGetBoxById(elt.id);
	};

	onAddClick = () => {
		this.props.initNewBox();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostBox(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchBox(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteBox(
			this.props.boxes.focus.data.id
		);
	};

	render() {
		const { boxes, centers } = this.props;
		const { focus, list } = boxes;
		const box = focus.data;
		const newBox =
			box !== null && box.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={{data: boxes.list.data.map(i => {return {...i, center: i.center ? i.center.name : 'AUCUN CENTRE'}})}}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="Boxes"
					addButtonText="Nouveau box"
					onAddButtonClick={this.onAddClick}
					defaultLabel={e => e.name}
					groupField='center'
					focusedEltId={box}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity="Boxes"
					icon='info'
					//importFunction={this.props.adminImportCenters}
				>
					{box !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: box.id,
								name: box.name ||'',
								abbreviation: box.abbreviation || '',
								center: box.center?.id || null,
								liveCallNumber: box.liveCallNumber || '',
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusBox}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={ 
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newBox ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newBox && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm errors={errors} centers={centers.list.data}/>
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex',
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0',
	},
};

const mapStateToProps = (state) => {
	return {
		boxes: state.admin.boxes,
		centers: state.admin.centers,
	};
};

const mapDispatchToProps = {
	adminGetAllBoxes,
	adminGetBoxById,
	adminPatchBox,
	adminDeleteBox,
	resetFocusBox,
	adminPostBox,
	initNewBox,
	adminGetAllCenters,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(BoxesAdmin);
